export default [
    {
        path: '/blog/posts',
        name: 'blogPostsList',
        component: () => import(/* webpackChunkName: "blog" */ '../views/posts/List.vue'),
        props: true,
    },
    {
        path: '/blog/posts/create',
        name: 'blogPostsCreate',
        component: () => import(/* webpackChunkName: "blog" */ '../views/posts/Form.vue')
    },
    {
        path: '/blog/posts/:id/edit',
        name: 'blogPostsEdit',
        component: () => import(/* webpackChunkName: "blog" */ '../views/posts/Form.vue')
    },
    {
        path: '/blog/types',
        name: 'blogTypesPostList',
        component: () => import(/* webpackChunkName: "blog" */ '../views/types/List.vue'),
        props: true,
    },
    {
        path: '/blog/types/create',
        name: 'blogTypesPostCreate',
        component: () => import(/* webpackChunkName: "blog" */ '../views/types/Form.vue')
    },
    {
        path: '/blog/types/:id/edit',
        name: 'blogTypesPostEdit',
        component: () => import(/* webpackChunkName: "blog" */ '../views/types/Form.vue')
    },
    {
        path: '/blog/categories',
        name: 'blogCategoriesList',
        component: () => import(/* webpackChunkName: "blog" */ '../views/categories/List.vue'),
        props: true,
    },
    {
        path: '/blog/categories/create',
        name: 'blogCategoriesCreate',
        component: () => import(/* webpackChunkName: "blog" */ '../views/categories/Form.vue')
    },
    {
        path: '/blog/categories/:id/edit',
        name: 'blogCategoriesEdit',
        component: () => import(/* webpackChunkName: "blog" */ '../views/categories/Form.vue')
    },
    {
        path: '/blog/sites',
        name: 'blogSitesList',
        component: () => import(/* webpackChunkName: "blog" */ '../views/sites/List.vue'),
        props: true,
    },
    {
        path: '/blog/sites/create',
        name: 'blogSitesCreate',
        component: () => import(/* webpackChunkName: "blog" */ '../views/sites/Form.vue')
    },
    {
        path: '/blog/sites/:id/edit',
        name: 'blogSitesEdit',
        component: () => import(/* webpackChunkName: "blog" */ '../views/sites/Form.vue')
    },
]